<div class="f-row custom-dialog">
    <div class="container d-justify-bw">
        <div class="verify-title">
            <div class="title">
            </div>
            <div class="close">
                <button mat-icon-button (click)="CloseDialog()">
                  <mat-icon fontSet="material-symbols-outlined">close</mat-icon>
                </button>
              </div>
        </div>
        <form>
            <div class="f-col d-align-center verify-body">
            <div class="illustration-wrapper">
                <div class="img-wrapper">
                    <img src="assets/images/illustrations--Reset.svg" class="illusutrations-small" alt="Reset" />
                </div>
            </div>

            <div class="title-wrapper">
                <h6 class="title-content">{{content?.['b2b.managecompany.successfullyuploaded']}} </h6>
                <span class="description">{{content?.['b2b.managecompany.profilescreatedsuccess'] || 'Traveler profiles have been successfully created on the portal. Each traveler will receive an email to create password and login.'}}</span>
            </div>
            </div>
        </form> 
    </div>
</div>